module.exports = __webpack_public_path__ + "static/media/Farmer.e7470973.jpg";